import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PAGE_ROUTE_PATH } from '@/constants';
import { useInternalRedirect } from '@/features/redirect';
import { useClearLocalStorage } from '@/hooks/useClearLocalStorage';
import { useCommonErrorDialog } from '@/hooks/useCommonErrorDialog';
import { isMobile } from '@/utils/device';

/**
 * アクセス期限切れ カスタムフック
 *
 * @returns
 */
export const useAccessExpired = () => {
  const { doCleanLocalStorage } = useClearLocalStorage();
  const navigate = useNavigate();
  const { resetState } = useCommonErrorDialog();
  const { internalRedirectToWelcome } = useInternalRedirect();

  /**
   * アクセス期限切れ
   */
  const accessExpired = useCallback(() => {
    // ローカルストレージの情報を全て削除
    doCleanLocalStorage();

    if (isMobile()) {
      // 利用方法選択画面に遷移(同タブ内)
      navigate(PAGE_ROUTE_PATH.SELECT_USAGE);

      return;
    }
    // ログイン画面に遷移(同タブ内)
    internalRedirectToWelcome();
  }, [doCleanLocalStorage, internalRedirectToWelcome, navigate]);

  /**
   * アクセス期限切れダイアログ用OKボタンのクリック処理
   */
  const clickAccessExpiredOKButton = useCallback(() => {
    // アクセス期限処理実行
    accessExpired();
    // エラーダイアログの情報をリセット
    resetState();
  }, [accessExpired, resetState]);

  return {
    clickAccessExpiredOKButton,
  };
};
